import React from 'react';
import Header from '../../../common/Header';
import { useTranslation } from 'react-i18next';
import { APP_ROUTES } from '../../../common/constants/Routes';
import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import CircularIndeterminate from '../../../common/CircularLoading';
import Table from '../../../common/Table';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../common/ui/CustomButton';
import { vechicelStatus } from '../../../common/constants/dropDownList';

function Stores() {
  const { t } = useTranslation();
  const loading = false;
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      headerName: t('STORE_NAME'),
      field: 'store_name',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('STORE_INCHARGE'),
      field: 'store_incharge',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('MOBILE_NUMBER'),
      field: 'mobile_number',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('LOCATIONS'),
      field: 'locations',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('ADDRESS'),
      field: 'address',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },

    {
      headerName: t('STATUS'),
      field: 'status',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: ({ row }: any) =>
        vechicelStatus.find(
          (data: any) => Number(data.Code) === Number(row?.status)
        )?.Category,
    },
    {
      headerName: t('ACTION'),
      field: 'Action',
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      renderCell: ({ row }: any) => {
        const handleEditClick = () => {
          navigate(APP_ROUTES.STOREEDit, {
            state: { data: { data: row, type: 'edit' } },
          });
        };

        const handleViewClick = () => {
          navigate(APP_ROUTES.STOREVIEW, {
            state: { data: { data: row, type: 'view' } },
          });
        };
        return (
          <>
            {' '}
            <CustomButton
              text={t('VIEW')}
              className='mx-3'
              color={'info'}
              onClick={handleViewClick}
            />
            <CustomButton
              text={t('EDIT')}
              className='mx-3 '
              onClick={handleEditClick}
              color={'error'}
            />
          </>
        );
      },
    },
  ];
  const data: any[] = [
    {
      id: '1',
      store_name: 'AK STORE',
      store_incharge: 'Gokul',
      locations: '11.460609932177377, 78.18497821807645',
      status: '1',
      address: '1/101A , Main Road , Rasipuram',
      mobile_number: '956656425',
      latitude: '11.460609932177377',
      longitude: '78.18497821807645',
    },
    {
      id: '2',
      store_name: 'LMN STORE',
      store_incharge: 'Gokul',
      locations: '11.460609932177377, 78.18497821807645',
      status: '2',
      address: '1/101A , Main Road , Rasipuram',
      mobile_number: '856656425',
      latitude: '11.460609932177377',
      longitude: '78.18497821807645',
    },
    {
      id: '3',
      store_name: 'BK STORE',
      store_incharge: 'Gokul',
      locations: '11.460609932177377, 78.18497821807645',
      status: '1',
      address: '1/101A , Main Road , Rasipuram',
      mobile_number: '756656425',
      latitude: '11.460609932177377',
      longitude: '78.18497821807645',
    },
  ];
  return (
    <div>
      <Header
        header={t('STORE')}
        buttonName={t('ADD_STORE')}
        route={APP_ROUTES.STOREADD}
        buttonIcon={AddIcon}
        view={true}
      />
      {loading ? (
        <Grid xs={12} my={5} display={'flex'} justifyContent={'center'}>
          <CircularIndeterminate />
        </Grid>
      ) : (
        <Grid xs={12} mb={5}>
          <Table
            // totalRecords={
            //   petitionTypeCount
            //     ? petitionTypeCount
            //     : petetionList?.totalRecords || 0
            // }
            rows={data}
            columns={columns}
            // handlePagination={handlePagination}
            // paginationModel={{
            //   page: Number(petetionList?.currentPage) - 1 || 0,
            //   pageSize: Number(petetionList?.pagesize) || 5,
            // }}
            rowHeight={60}
          />
        </Grid>
      )}
    </div>
  );
}
export default Stores;
